import { applyOAuth } from './oautApi';
import { syncQuestionnaire } from './syncQuestionnaire';

export default [applyOAuth, syncQuestionnaire];
